import type { ProductProps } from 'tsconfig/types';

interface Props {
  product: ProductProps | null;
  upsellProduct: ProductProps | null;
  upsellSelected: boolean;
}

export const ProductLabel = ({ product, upsellProduct, upsellSelected }: Props) => {
  const bottles = product?.skus?.[0]?.numberOfBottles ?? 0;
  const productName = product?.name ?? '';

  let bottleLabel = '';
  if (bottles > 0) {
    const plural = bottles === 1 ? '' : 's';
    bottleLabel = `(${bottles} btl${plural})`;
  }

  const upsellLabel = upsellProduct && upsellSelected ? `+ ${upsellProduct.name}` : '';

  return (
    <span>
      {productName} {bottleLabel} {upsellLabel && `${upsellLabel}`}:
    </span>
  );
};
